module.exports = __webpack_public_path__ + "media/St 4-light switch-correct.1996aafa.wav";